import { REFRESH_AUTH_TOKEN, START_INTERVAL, RUNNING_INTERVAL, STOP_INTERVAL } from "./RefreshTokenTypes";

export const startInterval = () => (dispatch: any) => {
  dispatch({
    type: START_INTERVAL
  });
};

export const refreshAuthToken = (_expiredToken: Date, _expiredLogout: Date) => (dispatch: any) => {
  dispatch({
    type: REFRESH_AUTH_TOKEN,
    payload: {
      expiredToken: _expiredToken,
      expiredLogout: _expiredLogout
    }
  });
};

export const runningInterval = (_expiredToken: Date, _expiredLogout: Date) => async (dispatch: any) => {
  dispatch({
    type: RUNNING_INTERVAL,
    payload: {
      expiredToken: _expiredToken,
      expiredLogout: _expiredLogout
    }
  });
};

export const stopInterval = () => (dispatch: any) => {
  dispatch({
    type: STOP_INTERVAL
  });
};